import React, { useState, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import Modal from "react-bootstrap/Modal";
import {
  seleccionarCampo,
  formatMoneda,
  validaMonto,
  round,
  formatoMonto,
} from "../../util/varios";
import useTableScroll from "../useTableScroll";
import CatalogoProductoUpdate from "../../catalogos/catalogoProductoUpdate";

export const ActualizarProductos = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");

  const txtId = useRef([]);
  const txtIdproducto = useRef([]);
  const txtCosto = useRef([]);
  const txtPrecio = useRef([]);
  const btnIncluir = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitadoProductos, setHabilitadoProductos] = useState(true);
  const [habilitadoMod, setHabilitadoMod] = useState(false);
  const [indice, setIndice] = useState(null);
  const [mostrar, setMostrar] = useState(false);
  const [records, setRecords] = useState([]);
  const [activate, setActivate] = useState(false);
  const [body, setBody] = useState(null);
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "CODIGO", textAlign: "center", width: "0px" },
    { label: "DESCRIPCION", textAlign: "center" },
    { label: "UNIDAD", textAlign: "center" },
    { label: "COSTO", textAlign: "center" },
    { label: "PRECIO", textAlign: "center" },
    {
      label: <i className="fas fa-trash" />,
      textAlign: "center",
      width: "20px",
    },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const seleccionarProducto = (index, idprod) => {
    let campos = "*";
    let nomtab = `seleccionar_productos_update_codigo('${idprod}')`;
    let orden = "idproducto";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = [...records];
          if (response.data.length > 0) {
            for (let i = 0; i < records.length; i++) {
              if (records[i].idproducto === response.data[0].idproducto) {
                setActivate(false);
                setMensaje({
                  mostrar: true,
                  titulo: "Notificacion",
                  texto: "el producto ya ha sido seleccionado.",
                  icono: "error",
                });
                return;
              }
            }

            if (index !== null) {
              data[index] = {
                idproducto: response.data[0].idproducto,
                codigo: response.data[0].codigo,
                nombre: response.data[0].nombre,
                idtipoproducto: response.data[0].idtipoproducto,
                idunidadmedida: response.data[0].idunidadmedida,
                ivaventa: response.data[0].ivaventa,
                tipoprecio: response.data[0].tipoprecio,
                idunidadalterna: response.data[0].idunidadalterna,
                idunidadventa: response.data[0].idunidadventa,
                valorfactor: response.data[0].valorfactor,
                tipofactor: response.data[0].tipofactor,
                idmoneda: response.data[0].idmoneda,
                valormoneda: response.data[0].valormoneda,
                costo: response.data[0].costo,
                costoalter: response.data[0].costoalter,
                precio: response.data[0].precio,
                precioalter: response.data[0].precioalter,
                utilidad: response.data[0].utilidad,
                utilidadalter: response.data[0].utilidadalter,
                descripcionuni: response.data[0].descripcionuni,
                descripcionunialt: response.data[0].descripcionunialt,
                imagen: response.data[0].imagen,
              };
            } else {
              data.push({
                idproducto: response.data[0].idproducto,
                codigo: response.data[0].codigo,
                nombre: response.data[0].nombre,
                idtipoproducto: response.data[0].idtipoproducto,
                idunidadmedida: response.data[0].idunidadmedida,
                ivaventa: response.data[0].ivaventa,
                tipoprecio: response.data[0].tipoprecio,
                idunidadalterna: response.data[0].idunidadalterna,
                idunidadventa: response.data[0].idunidadventa,
                valorfactor: response.data[0].valorfactor,
                tipofactor: response.data[0].tipofactor,
                idmoneda: response.data[0].idmoneda,
                valormoneda: response.data[0].valormoneda,
                costo: response.data[0].costo,
                costoalter: response.data[0].costoalter,
                precio: response.data[0].precio,
                precioalter: response.data[0].precioalter,
                utilidad: response.data[0].utilidad,
                utilidadalter: response.data[0].utilidadalter,
                descripcionuni: response.data[0].descripcionuni,
                descripcionunialt: response.data[0].descripcionunialt,
                imagen: response.data[0].imagen,
              });
            }
            setRecords(data);
            setIndice(index);

            /*               if (index !== null) {
                setTimeout(() => txtCantidad.current[index].focus(), 300);
              } else {
                setTimeout(
                  () => txtCantidad.current[data.length - 1].focus(),
                  300
                );
              } */
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "no existe un producto con ese codigo.",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/cerveceria/actualizar/2`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords([]);
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: `${response.data.contar} registro modificado correctamente`,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const validarCosto = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let data = [...records];
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      let canti = parseFloat(
        event.target.value.replace(/\./g, "").replace(",", ".")
      );

      data[index].costo = canti;
      setRecords(data);
    }
  };

  const validarPrecio = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let data = [...records];
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      let canti = parseFloat(
        event.target.value.replace(/\./g, "").replace(",", ".")
      );

      data[index].precio = canti;
      setRecords(data);
    }
  };

  const validarIdProducto = (index) => (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProducto(index, event.target.value);
        event.target.value = "";
      }
    }
  };

  const agregarProducto = (producto) => {
    let data = [...records];
    let sigue = true;
    for (let i = 0; i < records.length; i++) {
      if (records[i].idproducto === producto.idproducto) {
        sigue = false;
      }
    }

    if (sigue) {
      if (indice !== null) {
        data[indice] = producto;
      } else {
        data.push(producto);
      }
      setRecords(data);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "el producto ya ha sido seleccionado.",
        icono: "error",
      });
    }

    setMostrar(false);
  };

  const seleccionarxIndice = (index) => (e) => {
    e.preventDefault();
    setMostrar(true);
    setIndice(index);
  };

  const eliminarProducto = (producto) => (e) => {
    e.preventDefault();
    let data = [...records];
    let elementos = [];

    for (let i = 0; i < data.length; i++) {
      if (producto.idproducto !== data[i].idproducto) {
        elementos.push(data[i]);
      }
    }
    setRecords(elementos);
  };

  const onChangeValidar = () => {
    let productos = [];
    for (let i = 0; i < records.length; i++) {
      console.log(records[i]);

      let labelcosto = "costoproveedor";
      let labelprecio = "preciomaxi";
      let labeluti = "utipreciomaxi";
      let labelprecioalter = "preciomaxialter";
      let labelcostoalter = "costoproveedoralter";
      let labelutialter = "utipreciomaxialter";

      const costo = parseFloat(records[i].costo);
      const precio = parseFloat(records[i].precio);
      const valorfactor = parseFloat(records[i].valorfactor);
      const utilidad = round(((precio - costo) / costo) * 100);

      if (parseInt(records[i].metodocosto) === 1) {
        labelcosto = "costoproveedor";
        labelcostoalter = "costoproveedoralter";
      }
      if (parseInt(records[i].metodocosto) === 2) {
        labelcosto = "costocalculado";
        labelcostoalter = "costocalculadoalter";
      }
      if (parseInt(records[i].metodocosto) === 3) {
        labelcosto = "ultimocosto";
        labelcostoalter = "ultimocostoalter";
      }
      if (parseInt(records[i].metodocosto) === 4) {
        labelcosto = "costopromedio";
        labelcostoalter = "costopromedioalter";
      }

      if (parseInt(records[i].tipoprecio) === 1) {
        labelprecio = "preciomaxi";
        labelprecioalter = "preciomaxialter";
        labeluti = "utipreciomaxi";
        labelutialter = "utipreciomaxialter";
      }
      if (parseInt(records[i].tipoprecio) === 2) {
        labelprecio = "precioofe";
        labelprecioalter = "precioofealter";
        labeluti = "utiprecioofe";
        labelutialter = "utiprecioofealter";
      }
      if (parseInt(records[i].tipoprecio) === 3) {
        labelprecio = "preciomayor";
        labelprecioalter = "preciomayoralter";
        labeluti = "utipreciomayor";
        labelutialter = "utipreciomayoralter";
      }
      if (parseInt(records[i].tipoprecio) === 4) {
        labelprecio = "preciomini";
        labelprecioalter = "preciominialter";
        labeluti = "utipreciomini";
        labelutialter = "utipreciominialter";
      }

      if (parseInt(records[i].tipofactor) === 1) {
        productos.push({
          codigo: records[i].codigo,
          [labelcosto]: costo,
          [labelprecio]: precio,
          [labeluti]: utilidad,
          [labelcostoalter]: round(costo / valorfactor),
          [labelprecioalter]: round(precio / valorfactor),
          [labelutialter]: utilidad,
        });
      } else {
        productos.push({
          codigo: records[i].codigo,
          [labelcosto]: costo,
          [labelprecio]: precio,
          [labeluti]: utilidad,
        });
      }
    }

    setBody({ productos: JSON.stringify(productos) });

    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Esta Seguro de Modificar estos Productos?",
      icono: "confirmacion",
    });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setActivate(false);
    setHabilitadoBot(true);
    setHabilitadoProductos(true);
    setVisibleBtn("visible");
    setRecords([]);
    setBody(null);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setHabilitadoBot(false);
      setVisibleBtn("hidden");
      setHabilitadoMod(true);
      setHabilitadoProductos(false);
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>Actualizar Precios </Modal.Title>
        <button
          onClick={cancelar}
          ref={btnCancela}
          className="btn btn-sm text-light"
        >
          <i className="fas fa-times fa-1x shadow"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="row col-md-12 " style={{ margin: 0 }}>
            <div className="row col-md-12 py-2" style={{ margin: 0 }}>
              <div
                className="col-md-12 border-azul px-0 rounded"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <div
                  className="input-group input-group-sm m-2"
                  style={{ width: 150 }}
                >
                  <input
                    type="text"
                    disabled={habilitadoProductos}
                    ref={txtIdproducto}
                    placeholder="CODIGO"
                    style={{
                      borderBottomRightRadius: 0,
                      borderTopRightRadius: 0,
                    }}
                    className="form-control form-control-sm bg-light text-right fs-6 col-pd-110"
                    onChange={(e) =>
                      (e.target.value = e.target.value.toUpperCase())
                    }
                    onKeyUp={validarIdProducto(null)}
                    onBlur={validarIdProducto(null)}
                  />
                  <button
                    type="button"
                    disabled={habilitadoProductos}
                    style={{
                      borderBottomLeftRadius: 0,
                      borderTopLeftRadius: 0,
                    }}
                    onClick={() => setMostrar(true)}
                    className="btn btn-sm btn-primary"
                  >
                    <i className="fas ">-</i>
                  </button>
                </div>

                <TblContainer
                  container={{
                    height: 400,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell
                            className="bg-light d-flex align-items-between px-0"
                            style={{ maxWidth: "500px" }}
                          >
                            <input
                              type="text"
                              style={{
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0,
                              }}
                              disabled={habilitadoProductos}
                              ref={(el) => (txtId.current[index] = el)}
                              className="form-control form-control-sm bg-light fs-6 col-pd-110"
                              defaultValue={item.codigo}
                              onChange={(e) =>
                                (e.target.value = e.target.value.toUpperCase())
                              }
                              onKeyUp={validarIdProducto(index)}
                              onBlur={validarIdProducto(index)}
                            />
                            <button
                              type="button"
                              style={{
                                borderBottomLeftRadius: 0,
                                borderTopLeftRadius: 0,
                              }}
                              disabled={habilitadoProductos}
                              onClick={seleccionarxIndice(index)}
                              className="btn btn-sm btn-primary"
                            >
                              <i className="fas ">-</i>
                            </button>
                          </TableCell>
                          <TableCell
                            className={`align-middle bg-light text-start p-0 pl-2`}
                          >
                            {item.nombre}
                          </TableCell>
                          <TableCell className="align-middle bg-light text-center p-0 col-pd-100">
                            {item.descripcionuni}
                          </TableCell>
                          <TableCell className="align-middle bg-light text-center p-0 col-pd-90">
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="costo"
                              disabled={!habilitadoMod}
                              defaultValue={formatMoneda(
                                item.costo
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtCosto.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarCosto(index)}
                              onBlur={validarCosto(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell className="align-middle bg-light text-center p-0 col-pd-90">
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="precio"
                              disabled={!habilitadoMod}
                              defaultValue={formatMoneda(
                                item.precio
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtPrecio.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarPrecio(index)}
                              onBlur={validarPrecio(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-center p-0"
                            style={{ width: "30px" }}
                          >
                            <button
                              disabled={habilitadoProductos}
                              onClick={eliminarProducto(item)}
                              className="btn btn-sm btn-danger"
                            >
                              <i className="fa fa-trash"></i>{" "}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
            </div>
          </div>

          <CatalogoProductoUpdate
            show={mostrar}
            onHideCancelar={() => {
              setMostrar(false);
            }}
            onHideAceptaCatalogo={agregarProducto}
          />
          <Dimmer active={activate} inverted>
            <Loader inverted>cargando...</Loader>
          </Dimmer>
          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              mensaje.titulo === "Exito."
                ? blanquear()
                : setMensaje({
                    mostrar: false,
                    titulo: "",
                    texto: "",
                    icono: "",
                  })
            }
          />
          <MensajeSiNo
            mensaje={mensajesino}
            onHideNo={() =>
              setMensajesino({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              })
            }
            onHideSi={handleCloseSi}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12 row mt-3">
          {visibleBtn === "visible" ? (
            <div className="col-pd-520">
              <div className="col-md-12 row m-0">
                <button
                  disabled={!habilitadoBot}
                  ref={btnIncluir}
                  onClick={onBotones(1)}
                  className="btn btn-sm col btn-primary rounded-pill"
                  title="Actualizar Precios"
                >
                  <i className="fas fa-edit"> Actualizar </i>{" "}
                </button>
              </div>
            </div>
          ) : (
            <div className="col-pd-540 row m-0 ml-auto">
              <button
                ref={btnAcepta}
                onClick={onBotones(5)}
                className="btn btn-sm rounded-pill btn-success col mx-1"
              >
                <i className="fas fa-check-circle"> Aceptar</i>
              </button>
              <button
                ref={btnCancela}
                disabled={habilitadoBot}
                onClick={onBotones(6)}
                className="btn btn-sm rounded-pill btn-danger col"
              >
                <i className="fas fa-window-close"> Cancelar</i>
              </button>
            </div>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/almacen/modalActualizarProductos.js